import { connect } from "react-redux";

import KompressorWartungTabelle from "./KompressorWartungTabelle";

export default connect(state => ({
	data: state.ablauf.maintenance,
	compressors: state.ablauf.compressors,
	units: state.units
}))(KompressorWartungTabelle);
